import type { PatientApiUpdateQuery } from "@/Modules/Patients/Models/Api";
import type { PatientInfoUpdateQuery } from "@/Modules/Patients/Models/Domain";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { updatePatient } from "@/Services/TherapyApi/Clients";
import PatientTransformer from "@/Modules/Transformers/Patients/Patient";

import usePatientsStore from "@/Modules/Patients/Store";
import useAppStore from "@/Modules/App/Store";

import { hasValue } from "@/Utils/Objects";

async function updatePatientAH(uuid: string, personalData: PatientInfoUpdateQuery): Promise<void> {
  const appStore = useAppStore();
  const patientsStore = usePatientsStore();

  if (!hasValue(uuid)) return undefined;

  patientsStore.isLoading = true;

  try {
    const apiQuery = transformDataToApiQuery(personalData);
    const patientApi = await updatePatient(uuid, apiQuery);
    const patientDomain = PatientTransformer.toDomain(patientApi);

    patientsStore.selected = patientDomain;

    appStore.showSnackbar({
      type: NotificationType.SUCCESS,
      message: "patients.personal_data.saved_notification",
    });
  } catch (err: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    patientsStore.isLoading = false;
  }
}

function transformDataToApiQuery(personalData: PatientInfoUpdateQuery): PatientApiUpdateQuery {
  return {
    name: personalData.name,
    age: personalData.age,
    education: personalData.education,
    relationship_status: personalData.relationshipStatus,
    presenting_issue: personalData.presentingIssue,
    mental_status_exam: personalData.mentalStatusExam,
    diagnostic: personalData.diagnostic,
    treatment_plan: personalData.treatmentPlan,
  };
}

export default updatePatientAH;
